export interface FAQ {
  question: string;
  answer: string;
}

export const faqs: FAQ[] = [
  {
    question: '8x8x水蜜桃是什么平台？',
    answer: '8x8x水蜜桃是一个综合性的数字内容平台，提供丰富的视频资源和互动社区服务。平台汇聚了大量优质内容，覆盖多个分类频道，致力于为用户打造极致的观看体验。',
  },
  {
    question: '如何找到8x8x水蜜桃最新地址？',
    answer: '您可以通过以下官方渠道获取8x8x水蜜桃最新地址：关注官方微信公众号、官方微博账号或官方Telegram频道。建议将官网加入浏览器收藏夹，以便随时快速访问。',
  },
  {
    question: '8x8x水蜜桃是否免费？',
    answer: '平台提供大量免费内容供用户体验。新用户注册即享7天免费体验特权。此外，每日免费专区、任务积分兑换和限时活动都可以获取免费观看时长。',
  },
  {
    question: '如何确保访问的是8x8x水蜜桃官网？',
    answer: '请认准官方页面特征：精美的专业设计、及时更新的内容、页面底部的完整备案信息。官方入口右上角有安全认证标识。切勿通过不明链接访问，避免进入仿冒网站。',
  },
  {
    question: '8x8x水蜜桃支持哪些设备？',
    answer: '平台支持全设备访问：Windows、Mac电脑端网页版，iOS和Android移动端APP。网页版无需下载安装，直接访问即可。APP可在官方渠道下载安装。',
  },
  {
    question: '个人信息在平台上安全吗？',
    answer: '安全。平台采用银行级TLS加密传输和AES-256数据存储加密。严格遵守隐私保护法规，绝不会向第三方泄露用户个人信息。',
  },
  {
    question: '忘记密码怎么办？',
    answer: '在登录页面点击"忘记密码"，通过绑定的手机号或邮箱接收验证码后即可重置密码。建议绑定手机号和邮箱双重验证方式，确保账号安全。',
  },
  {
    question: '可以在多个设备上同时登录吗？',
    answer: '支持多设备登录，但为了保护账号安全，同时在线设备数量有限制。建议不要在公共设备上保存登录状态，使用完毕后及时退出。',
  },
];

export function getFAQSchemaJSON() {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };
}